import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { List as ListComp } from '@alfa-bank/site-lists';

import { formatRegion, noop } from '../../helpers';
import { TransparentButton } from '../transparent-button';

import styles from './list.css';
import type { IListProps } from './models';

export const List: FC<IListProps> = ({ cities, className, onClick = noop }) => (
    <ListComp className={cn(styles.external, styles.list, className)} marker="" type="ul">
        {cities.map(city => (
            <TransparentButton
                key={city.fiasId}
                // eslint-disable-next-line external-classname/specificity
                className={styles.city}
                onClick={() => onClick(city)}
                tabIndex={0}
            >
                <Text
                    className={cn(styles.external, styles.name)}
                    tag="span"
                    view="component-primary"
                >
                    {city.cityNameRus}
                </Text>
                {city.hasNamesake && (
                    <Text
                        className={cn(styles.external, styles.region)}
                        tag="span"
                        view="primary-medium"
                    >
                        {formatRegion(city.regionName, city.regionType)}
                    </Text>
                )}
            </TransparentButton>
        ))}
    </ListComp>
);
